import React, { useState } from "react";
import { useFormikContext } from "formik";
import cloneDeep from "lodash/cloneDeep";
import { Spinner } from "components/common";
import { Button } from "components/bootstrap";
import { PATH_ACTIONS } from "./utils";
function CopyOptionsToAllButton({ ruleId, pathAction }) {
  var _a, _b, _c, _d, _e;
  const { values, setFieldValue, validateForm } = useFormikContext();
  const [copying, setCopying] = useState(false);
  const overridesKey = pathAction === PATH_ACTIONS.gitImport ? "rule_overrides" : "file_overrides";
  const options = (_a = values == null ? void 0 : values[overridesKey]) == null ? void 0 : _a[ruleId];
  const showCopyToAll = (pathAction === PATH_ACTIONS.gitImport ? (_c = (_b = values.rule_ids) == null ? void 0 : _b.length) != null ? _c : 0 : (_e = (_d = values.files) == null ? void 0 : _d.length) != null ? _e : 0) > 1;
  if (!showCopyToAll) return null;
  const copyRuleOptionsToAll = () => {
    var _a2;
    setCopying(true);
    const ruleIds = (_a2 = pathAction === PATH_ACTIONS.gitImport ? values.rule_ids : values.files.map((file) => file.name.split(".")[0])) == null ? void 0 : _a2.filter((id) => id !== ruleId);
    Promise.all((ruleIds == null ? void 0 : ruleIds.map((id) => setFieldValue(`${overridesKey}.${id}`, cloneDeep(options), false))) || []).then(() => validateForm()).then(() => {
      setCopying(false);
    });
  };
  return /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: copyRuleOptionsToAll, disabled: copying }, copying && /* @__PURE__ */ React.createElement(Spinner, { text: "" }), "Copy options to all selected rules");
}
export default CopyOptionsToAllButton;
